export const packagesColumns = [
    {
        name: "Packages Name",
        selector: (row) => row["name"],
        sortable: true,
        center: true,
        grow: 5,
        // style: {
        //     backgroundColor: "white",
        //     position: "sticky",
        //     left: 0,
        //     // zIndex: 0,
        // },
    },
    // {
    //     name: "DESCRIPTION",
    //     selector: (row) => row["description"],
    //     sortable: true,
    //     center: true,
    // },
    {
        name: "ACTIVE",
        selector: (row) => row["isActive"],
        sortable: true,
        center: true,
    },
    {
        name: "AUTO ROLLOVER",
        selector: (row) => row["autoRollover"],
        sortable: true,
        center: true,
        width: "145px"
    },
    {
        name: "AIRPORT EXPRESS",
        selector: (row) => row["isAirportExpress"],
        sortable: true,
        center: true,
        width: "160px"
    },
    {
        name: "SERVICE CITY",
        selector: (row) => row["serviceCityName"],
        sortable: true,
        center: true,
        width: "130px"
    },
    {
        name: "BASE FARE TAX",
        selector: (row) => row["baseFareTaxPercentage"],
        sortable: true,
        center: true,
        width: "180px"
    },
    {
        name: "SERVICE TAX",
        selector: (row) => row["serviceFareTaxPercentage"],
        sortable: true,
        center: true,
        width: "180px"
    },
    // {
    //     name: "ISAIRPORT BOOKING",
    //     selector: (row) => row["isAirportBooking"],
    //     sortable: true,
    //     center: true,
    // },
    {
        name: "",
        cell: (row) => row["action"],
        sortable: true,
        center: true,
        width: "50px",
        // style: {
        //     backgroundColor: "white",
        //     position: "sticky",
        //     right: 0,
        //     zIndex: 0,
        //     justifyContent: "center !important"
        //   },
    },
];

export const packageFilterColumns = [
    {
        name: "IS ACTIVE",
        value: "isActive",
        type: "boolean",
    },
    {
        name: "IS KIOSK",
        value: "isKiosk",
        type: "boolean",
    }
];

export const packagesRateColumns = [
    {
        name: "Package Distance",
        selector: (row) => row["pkgDistance"],
        sortable: true,
        center: true,
    },
    {
        name: "Minimum Package Distance",
        selector: (row) => row["minPkgDistance"],
        sortable: true,
        center: true,
    },
    {
        name: "Maximum Package Distance",
        selector: (row) => row["maxPkgDistance"],
        sortable: true,
        center: true,
    },
    {
        name: "Package Value",
        selector: (row) => row["packageValue"],
        sortable: true,
        center: true,
    },
    {
        name: "Package Name",
        selector: (row) => row["packagesName"],
        sortable: true,
        center: true,
    },
    {
        name: "Tax Inclusive",
        selector: (row) => row["isTaxInclusive"],
        sortable: true,
        center: true,
    },
    {
        name: "Time Based",
        selector: (row) => row["isTimeBased"],
        sortable: true,
        center: true,
    },
    {
        name: "Time From",
        selector: (row) => row["timeFrom"],
        sortable: true,
        center: true,
    },
    {
        name: "Time To",
        selector: (row) => row["timeTo"],
        sortable: true,
        center: true,
    },
    // {
    //     name: "IsAirportDrop",
    //     selector: (row) => row["isAirportDropPackage"],
    //     sortable: true,
    //     center: true,
    // },
    // {
    //     name: "IsNightFareTimeSlot",
    //     selector: (row) => row["isNightfareTimeSlot"],
    //     sortable: true,
    //     center: true,
    // },
    {
        name: "Package Time In Min",
        selector: (row) => row["pkgTimeInMin"],
        sortable: true,
        center: true,
    },
    {
        name: "Package Charge",
        selector: (row) => row["pkgCharge"],
        sortable: true,
        center: true,
    },
    {
        name: "Additional Per Km Charge",
        selector: (row) => row["addnlPerKmCharge"],
        sortable: true,
        center: true,
    },
    {
        name: "Additional Time Charge",
        selector: (row) => row["addnlTimeCharge"],
        sortable: true,
        center: true,
    },
    {
        name: "Additional Time Charge In Min",
        selector: (row) => row["addnlTimeChargeBlockInMin"],
        sortable: true,
        center: true,
    },
    {
        name: "Ride Type",
        selector: (row) => row["packageRideType"],
        sortable: true,
        center: true,
    },
    {
        name: "",
        cell: (row) => row["action"],
        sortable: true,
        center: true,
        width: "50px",
        // style: {
        //     backgroundColor: "white",
        //     position: "sticky",
        //     right: 0,
        //     zIndex: 0,
        //     justifyContent: "center !important"
        //   },
    },
];